import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { ForgingDetails } from 'pages/details/forging/ForgingDetails'
import { z } from 'zod'

export const forgingsSearchSchema = z.object({
  pc: z.string().optional(),
  view: z.string().optional(),
  minFilter: z.preprocess((value) => {
    if (typeof value === 'string') {
      if (value === 'Infinity') return Infinity
      if (value === '-Infinity') return -Infinity
      const parsed = parseFloat(value)
      if (isNaN(parsed)) return undefined
      return parsed
    }
    return value
  }, z.number().optional()),
  maxFilter: z.preprocess((value) => {
    if (typeof value === 'string') {
      if (value === 'Infinity') return Infinity
      if (value === '-Infinity') return -Infinity
      const parsed = parseFloat(value)
      if (isNaN(parsed)) return undefined
      return parsed
    }
    return value
  }, z.number().optional()),
  extension: z.string().optional(),
  indication: z.string().optional(),
})

export const Route = createFileRoute('/forging/$entryID')({
  component: ForgingDetails,
  validateSearch: zodValidator(forgingsSearchSchema),
})
